import {
  Box,
  Card,
  CardMedia,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import type { ConversationIllustrationInfo } from '../interfaces/ConversationIf'
import { LanguageContext } from '../util/LanguageContext'

type AnonymousConversationImageListProps = {
  date: string | undefined
  items: ConversationIllustrationInfo[] | undefined
  id?: string
}

export const AnonymousConversationImageList: React.FC<AnonymousConversationImageListProps> = ({
  date,
  items,
  id,
}) => {
  const regexp = /(mov|.3gp|.mp4|.ts|.webm|.mkv)$/i
  // スマホ用vh
  const [vh, setVh] = useState(window.innerHeight * 0.01)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  useEffect(() => {
    const handleResize = () => setVh(window.innerHeight * 0.01)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ textAlign: 'center', borderBottom: '2px solid #282828' }}>
                {date}
                {id ? (
                  <Box sx={{ fontSize: '18px' }}>
                    <Box>{translation['label_conversation_ID']}</Box>
                    <Box>{id}</Box>
                  </Box>
                ) : null}
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
      <TableContainer
        style={{
          maxHeight: `calc(${vh * 100}px - 170px)`,
          overflowY: 'auto',
        }}
      >
        <Table>
          <TableBody>
            {items?.map(row => (
              <TableRow>
                <TableCell
                  sx={{
                    border: 'none',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  />
                  <CardMedia
                    component={regexp.test(row.storage_path.split('?')[0]) ? 'video' : 'img'}
                    src={row.storage_path}
                    alt={row.text}
                    controls
                    sx={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
